import { initReveal } from '../common/reveal';

initReveal({ selector: '[data-reveal]', threshold: 0.18 });
